export default __webpack_public_path__ + "static/media/nigel_serious.bb3f01e2.svg";